import { useMemo } from 'react';
import { PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE } from 'src/components/Modals/PnlModal/consts';
import { PnlModalVariant } from 'src/components/Modals/PnlModal/types';
import { getIsZeroFeesActiveForMarket } from 'src/utils/zeroFees';

interface Params {
	marketIndex?: number;
	isPositivePnl?: boolean;
	variant: PnlModalVariant;
}

export default function usePnlModalCardImagePaths({
	marketIndex,
	isPositivePnl,
	variant: _variant,
}: Params) {
	const showZeroFeesBackground =
		marketIndex !== undefined &&
		getIsZeroFeesActiveForMarket({
			marketIndex,
			isPerp: true,
		});

	return useMemo(() => {
		// We use one pnl image for all variants for the time being.
		// const pnlDependentImagePathKey = isPositivePnl ? 'positive' : 'negative';

		// We currently only show a single image for the portfolio performance PnL card.
		// if (variant === 'portfolio-performance') {
		// 	return [
		// 		PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE.pnl.portfolio[
		// 			pnlDependentImagePathKey
		// 		],
		// 	];
		// }

		const zeroFeesImagePath =
			showZeroFeesBackground &&
			// Note, this can be `undefined` if we didn't add an image for this market index.
			PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE.zeroFees[marketIndex];

		return [
			...(zeroFeesImagePath ? [zeroFeesImagePath] : []),
			// ...[
			// 	PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE.pnl.position[
			// 		pnlDependentImagePathKey
			// 	],
			// ],
			...PNL_MODAL_CARD_IMAGE_PATHS_BY_TYPE.standard,
		];
	}, [showZeroFeesBackground, isPositivePnl, marketIndex]);
}
